import React from 'react';
import { Dialog, DialogContent, Typography, Box } from '@mui/material';
import shortLogo from '../assets/vester-logo-short.svg';

const ResponsiveModal = ({ open }) => {
  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.90)',
          zIndex: (theme) => theme.zIndex.drawer + 2,
        },
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            component="img"
            src={shortLogo}
            alt="Vester Logo"
            sx={{ height: 100, mb: 4 }}
          />
          <Typography variant="h5" sx={{ color: '#fff', fontWeight: 500, textAlign: 'center' }}>
            Vester is currently optimized for desktop use.
          </Typography>
          <Typography variant="h6" sx={{ color: '#fff', fontWeight: 400, mt: 1, textAlign: 'center' }}>
            Please open on a computer or expand your window for the best experience.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ResponsiveModal; 